import { IS_IOS } from 'helpers/userAgentHelpers'
import { NavigatorShareParams } from 'interfaces/navigator'

/**
 * Copy text to clipboard, works only in event handlers
 * @param text
 * @returns boolean True if copied, false if not
 */
export function copyToClipboard (text: string): boolean {
  const textareaEl = document.createElement('textarea')

  // prevent scrolling & zoom on mobile
  textareaEl.setAttribute('readonly', '')

  textareaEl.value = text
  document.body.appendChild(textareaEl)

  let operationResult = false

  try {
    if (IS_IOS) {
      const range = document.createRange()
      range.selectNodeContents(textareaEl)
      const selection = window.getSelection()
      if (!selection) {
        return false
      }
      selection.removeAllRanges()
      selection.addRange(range)
      textareaEl.setSelectionRange(0, 999999)
    } else {
      textareaEl.select()
    }

    document.execCommand('copy')
    operationResult = true
  } catch (O_o) {
    operationResult = false
  }
  document.body.removeChild(textareaEl)

  return operationResult
}

export function isSupportingShareApi (): boolean {
  return 'share' in navigator
}

export function share (params: NavigatorShareParams) {
  const noop = () => null
  navigator.share(params).catch(noop)
}
